<template>
  <VModal :type="ModalType.custom" :color="ColorType.gray" :isScroll="false">
    <VBlock class="coupon-baemin-point-wrapper" :sort="Sort.left_top" :direction="Direction.column">
      <VBlock class="coupon-baemin-point-header" :sort="Sort.space_between">
        <VBlock class="stock-wrapper">
          <VStockButton :type="StockButtonType.exit" :clickEvent="onExit" :width="16" :height="16" />
        </VBlock>
        <VSpan class="text" text="배민포인트" :size="16" :weight="TextWeight.bold" />
        <div class="blank"></div>
      </VBlock>
      <VBlock
        class="coupon-baemin-point-contents"
        ref="scrollLayer"
        :direction="Direction.column"
        :sort="Sort.left_top"
        :padding="[50, 15, 0, 15]"
      >
        <IOdometer
          :duration="300"
          :value="availableBaeminPointExceptSpent"
          animation="smooth"
          class="iOdometer"
        />

        <VBlock :margin="[0, 0, 30, 0]" :direction="Direction.column" :sort="Sort.left_top">
          <VSpan class="info-text" :size="16" text="1원 이상" />
          <VSpan class="info-text" :size="16" text="1원 단위로 사용 가능합니다" />
        </VBlock>
        <VInput
          :value="spentBaeminPoint === null ? '' : spentBaeminPoint.toString()"
          placeholder="사용할 포인트를 입력하세요."
          :onChanged="
            event => {
              onSpentBaeminPoint(event.target.value)
            }
          "
          pattern="\d*"
          min="1"
          step="1"
          type="tel"
          id="baemin-point-input"
        />
        <VCheckBox
          name="spent-all-baemin-point"
          :checked="spentAllBaeminPoint"
          :onChecked="onSpentAllBaeminPoint"
        >
          <VSpan text="모두 사용" :size="14" />
        </VCheckBox>
      </VBlock>

      <VBlock class="coupon-baemin-point-footer" :direction="Direction.column">
        <VButton
          class="coupon-baemin-point-apply-button"
          :radius="4"
          :style="{ opacity: invalidSpentBaeminPoint ? '0.3' : '1' }"
          :color="invalidSpentBaeminPoint ? ButtonColor.inactive : ButtonColor.brand"
          :onClick="doSpent"
        >
          <VSpan text="사용하기" :color="TextColor.white" :size="18" :weight="TextWeight.bold" />
        </VButton>
      </VBlock>
    </VBlock>
  </VModal>
</template>

<script>
import IOdometer from 'vue-odometer'
import 'odometer/themes/odometer-theme-default.css'

import VHR, { LineColor } from '@/presentationals/v2/components/layouts/atoms/VHR'
import VP from '../../atoms/VP'
import VA from '@/presentationals/v2/components/layouts/molecules/VA'

import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VStockButton, {
  StockButtonType
} from '@/presentationals/v2/components/layouts/atoms/VStockButton'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'
import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'
import VModal, {
  ModalType,
  ColorType
} from '@/presentationals/v2/components/layouts/molecules/VModal'

import selectedIcon from '@/assets/images/confirm-input-24.svg'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import VInput from '../../atoms/VInput/index'
import VCheckBox from '../../atoms/VCheckBox/index'

export default {
  name: 'ModalBaeminPoint',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VCheckBox,
    VInput,
    VP,
    VButton,
    VHR,
    VA,
    VImage,
    VSpan,
    VStockButton,
    VBlock,
    VCard,
    VList,
    VListItem,
    VModal,
    IOdometer
  },
  methods: {
    onSpentBaeminPoint(baeminPointString) {
      const isEmptyString = baeminPointString === ''
      const existOnlyNotDigit = !/\d+/.test(baeminPointString) && /\D+/.test(baeminPointString)
      if (isEmptyString || existOnlyNotDigit) {
        this.spentBaeminPoint = null
        return
      }

      const baeminPointEntered = Number(baeminPointString.replace('.', '')) || 0
      const maximumSpentBaeminPoint = Math.min(
        this.maximumUsableBaeminPoint,
        this.availableBaeminPoint
      )
      const toggleWhenAllBaeminPointChanged =
        this.spentAllBaeminPoint && baeminPointEntered < maximumSpentBaeminPoint

      if (toggleWhenAllBaeminPointChanged) {
        this.spentAllBaeminPoint = !this.spentAllBaeminPoint
      }

      this.spentBaeminPoint = Math.min(maximumSpentBaeminPoint, baeminPointEntered)
    },

    onSpentAllBaeminPoint() {
      this.spentAllBaeminPoint = !this.spentAllBaeminPoint

      if (!this.spentAllBaeminPoint) {
        this.spentBaeminPoint = 0
        return
      }

      this.onSpentBaeminPoint(`${this.params.baeminPoint.availableAmount}`)
    },

    onExit() {
      this.onOK()
    },

    onKeyDown(event) {
      const numHasDot = event.key === '.'
      if (numHasDot) {
        event.preventDefault()
      }
    },

    doSpent() {
      if (this.invalidSpentBaeminPoint) return

      const spentBaeminPoint = this.spentBaeminPoint

      const use = spentBaeminPoint > 0
      const spentAmount = use ? spentBaeminPoint : null

      this.params.onBaeminPoint({ use, spentAmount })

      this.onOK()
    }
  },
  created() {
    const { appVersion } = this.$store.getters
    this.$store.commit('hideNavigationBar', { appVersion })
  },
  mounted() {
    // disabled 되지 않았으면서, 배민포인트가 아닌 input 리스트들
    const avaliableInputElements = this.$store.getters['modal/availableInputs']
    const inputNotBaeminPoint = Array.from(avaliableInputElements).filter(
      input => !(input.id === 'baemin-point-input' || input.type === 'checkbox')
    )

    if (!!this.$refs.scrollLayer) disableBodyScroll(this.$refs.scrollLayer.$el)
    this.inputNotBaeminPoint = inputNotBaeminPoint

    this.inputNotBaeminPoint.forEach(list => {
      if (!list.disabled) list.disabled = true
    })
  },
  beforeDestroy() {
    const { appVersion } = this.$store.getters
    this.$store.commit('showNavigationBar', { appVersion })
    if (!!this.$refs.scrollLayer) enableBodyScroll(this.$refs.scrollLayer.$el)

    this.inputNotBaeminPoint.forEach(list => {
      if (list.disabled) list.disabled = false
    })
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      ColorType,
      LineColor,
      inputNotBaeminPoint: null,
      spentBaeminPoint: this.params.baeminPoint.use ? this.params.baeminPoint.spentAmount : null,
      spentAllBaeminPoint: false,

      resources: {
        selectedIcon
      }
    }
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    },

    maximumUsableBaeminPoint() {
      return this.params.maximumUsableBaeminPoint
    },

    availableBaeminPoint() {
      return this.params.baeminPoint.availableAmount
    },

    availableBaeminPointExceptSpent() {
      return this.availableBaeminPoint - this.spentBaeminPoint
    },

    invalidSpentBaeminPoint() {
      const spentBaeminPoint = this.spentBaeminPoint

      const isNull = spentBaeminPoint === null
      const isNotANumber = isNaN(spentBaeminPoint)
      const isLessThanZero = spentBaeminPoint < 0

      return isNull || isNotANumber || isLessThanZero
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.iOdometer {
  letter-spacing: -0.71px;
  font-size: 30px;
  letter-spacing: normal;
  font-weight: bold;
  font-family: 'APPLE SD Gothic NEO', 'Noto Sans CJK KR', sans-serif;
}

.coupon-baemin-point-wrapper {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-color: $background-white;

  .coupon-baemin-point-header {
    padding: 10px 15px 10px 15px;
    align-items: center;
    box-sizing: border-box;
    background-color: $background-white;
    /* border-bottom: 1px solid $light-gray-4; */

    .text {
      height: 19px;
      vertical-align: middle;
    }

    .stock-wrapper {
      width: 24px;
      height: 24px;
    }

    .blank {
      width: 30px;
    }
  }

  .coupon-baemin-point-contents {
    .coupon-baemin-point-text {
      margin-bottom: 15px;
      letter-spacing: -0.71px;
      color: $gray;
    }

    .info-text {
      letter-spacing: -0.38px;
      color: $gray;
    }
  }

  .coupon-baemin-point-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: 10px;
    margin-bottom: calc(constant(safe-area-inset-bottom) + 10px);
    margin-bottom: calc(env(safe-area-inset-bottom) + 10px);
    width: 100%;
    height: 50px !important;
    box-sizing: border-box;
    padding: 0 10px;

    .coupon-baemin-point-apply-button {
      width: 100%;
      height: 50px !important;
    }
  }
}
</style>
